import { useTranslation } from 'react-i18next'

import { CalendarRailBlock } from '../CalendarRailBlock'

import { CalendarRailSource } from './CalendarRailSource'
import { CALENDAR_RAIL_SOURCES } from './CalendarRailSources.constants'
import {
  getCalendarRailNextSources,
  getIsCalendarRailSourceChecked,
} from './CalendarRailSources.utils'

// TODO: leave out the follow-ups source when the user may not see follow-up
// dates, once the backend serves that right.
function CalendarRailSources({ sources, onChange }) {
  const { t } = useTranslation()

  function handleChangeSource({ isChecked, source }) {
    onChange({
      sources: getCalendarRailNextSources({ isChecked, source, sources }),
    })
  }

  return (
    <CalendarRailBlock title={t('Calendar.RailSourcesKey')}>
      {CALENDAR_RAIL_SOURCES.map(source => (
        <CalendarRailSource
          isChecked={getIsCalendarRailSourceChecked({ source, sources })}
          key={source.id}
          source={source}
          onChange={handleChangeSource}
        />
      ))}
    </CalendarRailBlock>
  )
}

export default CalendarRailSources
